import React from 'react';
import { useNavigate } from 'react-router-dom';

export function ClientQuickActions({ clientId }) {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Book Meeting',
      onClick: () => navigate(`/meetings/new?client=${clientId}`),
      testId: 'quick-action-meeting',
    },
    {
      label: 'New Contract',
      onClick: () => navigate(`/documents/new?client=${clientId}`),
      testId: 'quick-action-contract',
    },
    {
      label: 'New Invoice',
      onClick: () => navigate(`/transactions/new?client=${clientId}&type=invoice`),
      testId: 'quick-action-invoice',
    },
    {
      label: 'New Shoot',
      onClick: () => navigate(`/productions/new?client=${clientId}`),
      testId: 'quick-action-shoot',
    },
  ];

  return (
    <div className="pt-4 border-t border-border">
      <h3 className="text-sm font-medium text-foreground mb-3" data-testid="quick-actions-heading">
        Quick Actions
      </h3>
      <div className="grid grid-cols-2 gap-3">
        {actions.map((action) => (
          <button
            key={action.testId}
            onClick={action.onClick}
            className="bg-secondary hover:bg-secondary/80 text-foreground border border-border rounded-lg px-4 py-3 text-sm font-medium transition-colors"
            data-testid={action.testId}
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
}
